import { createComponentPreviewMapperModel } from '@wix/editor-elements-integrations';
import { composeMapper } from '@wix/editor-elements-preview-utils';
import type { PreviewWrapperProps } from '@wix/editor-elements-types/thunderboltPreview';

import type {
  TextOnPathDefinition,
  TextOnPathPreviewWrapperProps,
} from '../TextOnPath.types';
import { props as viewerPropsMapper, stateRefs } from './TextOnPath.mapper';

const props = composeMapper<
  PreviewWrapperProps<{
    previewWrapperProps?: TextOnPathPreviewWrapperProps;
  }>,
  TextOnPathDefinition
>()(
  viewerPropsMapper,
  {
    add: [
      'isPlayingAllowed',
      'styleProperties',
      'compData',
      'componentViewMode',
      'compPreviewState',
    ],
  },
  (resolver, deps, carmiProps) => {
    const viewerProps = resolver(deps, carmiProps);
    const {
      isPlayingAllowed,
      styleProperties,
      compData,
      componentViewMode,
      compPreviewState,
    } = deps;

    // Force reduced motion in editor preview, use state ref value in live site
    const forceReducedMotion = componentViewMode === 'editor';
    const isPreviewAnimationActive =
      !!compPreviewState?.includes('previewAnimation');

    return {
      ...viewerProps,
      animate: isPreviewAnimationActive || isPlayingAllowed,
      reducedMotion: forceReducedMotion || viewerProps.reducedMotion,
      previewWrapperProps: {
        font: styleProperties.font,
        fontSize: compData.fontSize,
        text: compData.text,
        fillMode: compData.fillMode,
        speed: compData.speed,
        movementDirection: compData.movementDirection,
        isPreviewAnimationActive,
      },
    };
  },
);

export default createComponentPreviewMapperModel({
  props,
  stateRefs,
});
